import { useContext } from 'react';

import { useLazyQuery, useMutation, useQuery, useApolloClient } from '@apollo/client';

import { useHttpClient, useHttpQuery } from '../hooks/useHttp';
import { ServiceContext } from './serviceContext';
import { ServiceType } from './types';

export const useService = () => {
  const context = useContext<{ serviceType: ServiceType }>(ServiceContext);
  // console.log(context);
  if (!context) {
    throw new Error('useService must be used within a ServiceContextProvider');
  }

  if (context.serviceType === ServiceType.GRAPHQL) {
    return {
      ...context,
      useLazyQuery,
      useMutation,
      useQuery,
      client: useApolloClient,
    };
  }

  return {
    ...context,
    useLazyQuery: useHttpQuery,
    useMutation: useHttpQuery,
    useQuery: useHttpQuery,
    client: useHttpClient,
  };
};
